import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Container,
  IconButton,
  TextField,
} from "@mui/material";
import { ConsultantuseAuth } from "../../security/ConsultantUseAuth";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

import { Consultant_Get_One_From_MongoDB } from "../../api/Consultant_Get_One_From_MongoDB";
import GetClientAddress from "../../../functions/GetClientAddress";
import { Get_One_From_MongoDB } from "../../api/Get_One_From_MongoDB";
import { Consultant_Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Consultant_Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";

import { Get_All_From_MongoDB_With_Search_Prop_In_Array } from "../../api/Get_All_From_MongoDB_With_Search_Prop_In_Array";
import { Arr_SEFPages } from "../../../arrays/SEF/Arr_SEFPages";

import "./ConsultantBookings.css";
import ConsultantBookingTable from "./components/ConsultantBookingTable";
import ConsultantBookingCards from "./components/ConsultantBookingCards";
import { Get_All_From_MongoDB_Choose_Fields_With_Search_Prop_In_Array } from "../../api/Get_All_From_MongoDB_Choose_Fields_With_Search_Prop_In_Array";
import { Get_One_Choose_Fields_From_MongoDB } from "../../api/Get_One_Choose_Fields_From_MongoDB";
import { Get_All_Non_Archived_Attendees_From_Array } from "../../api/Get_All_Non_Archived_Attendees_From_Array";
import { Send_Summer_SEF_Emails } from "./api/Send_Summer_SEF_Emails";

const ConsultantBookings = () => {
  const { logoutConsultant } = ConsultantuseAuth();

  //------------------------------------------Width Stuff

  let widthLimit = 1000;
  const [screenWidth, setscreenWidth] = useState(
    window.innerWidth <= widthLimit ? "Small" : "Big"
  );

  useEffect(() => {
    const handleResize = () => {
      setscreenWidth(window.innerWidth <= widthLimit ? "Small" : "Big");
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function isMobile() {
    return (
      /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Opera Mini|IEMobile|WPDesktop/i.test(
        navigator.userAgent
      ) || screenWidth === "Small"
    );
  }

  const [View, setView] = useState(isMobile() ? "Cards" : "Table");

  //----------------------------------------------------------

  //Get EC Data
  const [obj_EC, setobj_EC] = useState({});
  useEffect(() => {
    const fetchECData = async () => {
      Get_One_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        setobj_EC,
        logoutConsultant
      );
    };
    fetchECData();
  }, []);

  //Get Agency Data
  const [obj_Agency, setobj_Agency] = useState({});
  useEffect(() => {
    if (obj_EC.MetaData?.Agency_id && obj_EC.MetaData.Agency_id.length > 0) {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "Agencies",
        obj_EC.MetaData.Agency_id,
        {
          "MetaData.IP_id": 1,
          _id: 1,
          BasicInfo: 1,
        },
        setobj_Agency
      );
    }
  }, [obj_EC]);
  //Get All ECs if Admin
  const [Arr_ECs, setArr_ECs] = useState([]);
  useEffect(() => {
    if (obj_EC.MetaData?.Admin === "Yes") {
      const fetchAttendeeData = async () => {
        Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
          "IP",
          "EC",
          { "MetaData.Agency_id": obj_EC.MetaData?.Agency_id },
          100,
          setArr_ECs,
          {},
          { _id: 1, BasicInfo: 1 },
          logoutConsultant
        );
      };
      fetchAttendeeData();
    }
  }, [obj_EC]);
  //Part 1, get bookings data
  const [Arr_Bookings, setArr_Bookings] = useState([]);
  useEffect(() => {
    const fetchAttendeeData = async () => {
      if (obj_EC.MetaData?.Admin === "Yes") {
        let Arr_ECs_IDs = Arr_ECs.map((obj) => obj._id);
        Get_All_Non_Archived_Attendees_From_Array(
          "Registers_2025",
          "All",
          "IPInfo.EC_ID",
          Arr_ECs_IDs,
          {
            BasicInfo: 1,
            Contacts: 1,
            IPInfo: 1,
            SEFProgress: 1,
            VISA: 1,
            SEFInfo: 1,
            Notes: 1,
            SummerArrivalDeparture: 1,
          },
          setArr_Bookings,
          logoutConsultant
        );
      } else {
        Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
          "Registers_2025",
          "All",
          {
            "IPInfo.EC_ID": localStorage.getItem("Consultant_id"),
            "MetaData.Archived": { $ne: "Yes" },
          },
          1000,
          setArr_Bookings,
          {},
          {
            BasicInfo: 1,
            Contacts: 1,
            IPInfo: 1,
            SEFProgress: 1,
            VISA: 1,
            SEFInfo: 1,
            Notes: 1,
            SummerArrivalDeparture: 1,
          },
          logoutConsultant
        );
      }
    };
    fetchAttendeeData();
  }, [obj_EC, Arr_ECs]);

  //part 2, get all id's from bookings
  const getCompiledArray = async () => {
    // Wait for the state to update
    return new Promise((resolve) => {
      setTimeout(() => {
        let Arr_Bookingid = Arr_Bookings.map((obj) => obj._id);
        resolve(Arr_Bookingid);
      }, 100);
    });
  };

  //part 3, use the id's from bookings to find all invoices
  const [Arr_Invoices, setArr_Invoices] = useState([]);
  const fetchInvoiceData = async () => {
    const compiledArray = await getCompiledArray();

    Get_All_From_MongoDB_With_Search_Prop_In_Array(
      "Invoices",
      "Xero_2025",
      "Attendees.Attendee_id",
      compiledArray,
      setArr_Invoices,
      logoutConsultant
    );
  };

  //Triger this serach for invoices when Arr_Bookings changes
  useEffect(() => {
    const fetchData = async () => {
      // Part 1: Fetch attendee data
      //await fetchAttendeeData();
      // Part 2: Get all IDs from bookings
      const compiledArray = await getCompiledArray();
      // Part 3: Use the IDs from bookings to find all invoices
      await fetchInvoiceData(compiledArray);
    };
    fetchData();
  }, [Arr_Bookings]);

  function handleOpenBespokeForm() {
    window.open(
      `${GetClientAddress()}Public/RegistrationForm/${localStorage.getItem(
        "Consultant_id"
      )}`
    );
  }

  function handleOpenInvoices() {
    window.location.href = `${GetClientAddress()}Consultant/ConsultantInvoices`;
  }

  function countUnpaidInvoices(obj_Attendee) {
    return Arr_Invoices.filter(
      (invoice) => invoice.Paid_Status === "UnPaid" && invoice.Amount == 950
    ).some((obj_Invoice) =>
      obj_Invoice.Attendees.some(
        (attendee) => attendee.Attendee_id === obj_Attendee._id
      )
    ) ? (
      <button
        onClick={handleOpenInvoices}
        class="w3-button  w3-padding-large"
        style={{
          textAlign: "center",
          color: "black",
          backgroundColor: "rgba(209, 18, 18, 0.5)",
        }}
      >
        UnPaid Deposit Remaining
        <i class="fa fa-long-arrow-right" style={{ marginLeft: "10px" }}></i>
      </button>
    ) : Arr_Invoices.filter((invoice) => invoice.Paid_Status === "UnPaid").some(
        (obj_Invoice) =>
          obj_Invoice.Attendees.some(
            (attendee) => attendee.Attendee_id === obj_Attendee._id
          )
      ) ? (
      <button
        onClick={handleOpenInvoices}
        class="w3-button  w3-padding-large"
        style={{
          textAlign: "center",
          color: "black",
          backgroundColor: "rgba(209, 18, 18, 0.5)",
        }}
      >
        UnPaid Invoices Remaining
        <i class="fa fa-long-arrow-right" style={{ marginLeft: "10px" }}></i>
      </button>
    ) : (
      <button
        onClick={handleOpenInvoices}
        class="w3-button  w3-padding-large"
        style={{
          backgroundColor: "rgba(6, 134, 47, 0.5)",
          textAlign: "center",
          color: "black",
        }}
      >
        All Invoices Paid{" "}
        <i class="fa fa-long-arrow-right" style={{ marginLeft: "10px" }}></i>
      </button>
    );
  }

  let Arr_BasicSEFPages = Arr_SEFPages.filter((obj) => obj.level === "Basic");
  let Arr_AdvancedSEFPages = Arr_SEFPages.filter(
    (obj) => obj.level === "Advanced"
  );

  //Create a functiob that, when given an "Attendee", checks if all the SEF pages are complete by checking every value of Prop in Arr_BasicSEFPages, and making sure that every value of Attendee.SEFProgress.Prop === "Complete"
  function checkSEFProgress(obj_Attendee, Array_Level) {
    if (
      Array_Level.every(
        (obj_level) =>
          obj_Attendee.SEFProgress &&
          obj_Attendee.SEFProgress[obj_level.Prop] &&
          obj_Attendee.SEFProgress[obj_level.Prop] === "Complete"
      )
    ) {
      return "Complete";
    } else if (
      Array_Level.every(
        (obj_level) =>
          obj_Attendee.SEFProgress &&
          obj_Attendee.SEFProgress[obj_level.Prop] &&
          (obj_Attendee.SEFProgress[obj_level.Prop] === "Complete" ||
            obj_Attendee.SEFProgress[obj_level.Prop] === "Awaiting_Review")
      )
    ) {
      return "Awaiting Review";
    } else if (
      Array_Level.some(
        (obj_level) =>
          obj_Attendee.SEFProgress &&
          obj_Attendee.SEFProgress[obj_level.Prop] &&
          (obj_Attendee.SEFProgress[obj_level.Prop] === "Complete" ||
            obj_Attendee.SEFProgress[obj_level.Prop] === "Awaiting_Review" ||
            obj_Attendee.SEFProgress[obj_level.Prop] === "In_Progress")
      )
    ) {
      return "In Progress";
    } else {
      return "Incomplete";
    }
  }

  function handleExpand(e, obj_Attendee) {
    e.preventDefault();
    //use setArr_Bookings and find the obj_Attendee in the array and set the value of Expand to "Yes", or "No" if it is already "Yes"
    let Arr_Bookings_Copy = Arr_Bookings.map((obj) => {
      if (obj._id === obj_Attendee._id) {
        return { ...obj, Expand: obj.Expand === "Yes" ? "No" : "Yes" };
      } else {
        return obj;
      }
    });
    setArr_Bookings(Arr_Bookings_Copy);
  }

  function handleOpenSEFPage(e, obj_booking, obj_SEFPage) {
    e.preventDefault();
    window.open(
      `${GetClientAddress()}Consultant/${obj_SEFPage.link}/${obj_booking._id}`,
      "_blank"
    );
  }

  //Send SEF to parent/attendee

  function handleSendSEFPage(e, Attendee) {
    e.preventDefault();
    let newNote = {
      DateTime: new Date().toISOString(),
      Note: "General SEF Email Sent",
      Staff_ID: localStorage.getItem("Consultant_id"),
    };
    //Check contacts and make the right format
    const Contacts = Attendee.Contacts || [];
    console.log("Contacts");
    console.log(Contacts);

    const AttendeeEmail = Contacts.find(
      (contact) => contact.Person === "Attendee"
    );
    const ParentEmail = Contacts.find((contact) => contact.Person === "Parent");
    let customer;
    if (AttendeeEmail || ParentEmail) {
      customer = {
        _id: Attendee._id,
        BasicInfo: Attendee.BasicInfo,
        IPInfo: Attendee.IPInfo || {},
        Password: Attendee.Password,
        Contacts: [AttendeeEmail, ParentEmail].filter((contact) => contact),
        dueEmail: "General SEF Email Sent",
      };
    } else {
      window.alert(
        "No Attendee or Parent contact email availible, please complete the Contacts section first"
      );
      return;
    }
    //End right format
    Send_Summer_SEF_Emails(customer, newNote, logoutConsultant);
  }
  //------------------Filter everything

  const [FilterEverything, setFilterEverything] = useState("");
  const handleFilterEverything = (e) => {
    setFilterEverything(e.target.value);
  };
  const Arr_Bookings_Filtered = Arr_Bookings.filter((obj_booking) => {
    return FilterEverything.split(" ").every((word) => {
      return Object.values(obj_booking).some((value) => {
        if (typeof value === "object") {
          return Object.values(value).some((value2) => {
            return value2.toString().toLowerCase().includes(word.toLowerCase());
          });
        }
        return value.toString().toLowerCase().includes(word.toLowerCase());
      });
    });
  });

  const ProgressLegend = () => {
    const stages = [
      {
        title: "Incomplete",
        description: "No progress has been made yet.",
        description2: "Action Needed",
        color: "rgba(255, 0, 0, 0.3)", // Red
      },
      {
        title: "In Progress",
        description:
          "This form has been started, but has not yet been submitted.",
        description2: "Action Needed",
        color: "rgba(255, 165, 0, 0.3)", // Orange
      },
      {
        title: "Awaiting Review",
        description:
          "Submitted and will be reviewed by our team. We will reach out if we need anything further.",
        description2: "No Action Needed",
        color: "rgba(255, 255, 0, 0.3)", // Yellow
      },
      {
        title: "Complete",
        description: "Form approved.",
        description2: "No Action Needed",
        color: "rgba(0, 255, 0, 0.3)", // Green
      },
    ];

    return (
      <div
        style={{
          display: "flex",
          flexDirection: screenWidth === "Big" ? "row" : "column",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "20px 0",
          position: "relative",
        }}
      >
        {stages.map((stage, index) => (
          <div
            key={index}
            style={{
              flex: 1,
              margin: "0 10px",
              padding: "20px",
              borderRadius: "8px",
              backgroundColor: stage.color,
              textAlign: "center",
              position: "relative",
            }}
          >
            <h3 style={{ margin: "0", color: "#000" }}>{stage.title}</h3>
            <p style={{ margin: "10px 0 0", color: "#333" }}>
              {stage.description2 === "Action Needed" ? (
                <b>
                  <i>{stage.description2}</i>
                </b>
              ) : (
                <i>{stage.description2}</i>
              )}
            </p>
            <p style={{ margin: "10px 0 0", color: "#333" }}>
              {stage.description}
            </p>
            {screenWidth === "Big" && index < stages.length - 1 && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "-20px",
                  transform: "translateY(-50%)",
                  width: "40px",
                  height: "2px",
                  backgroundColor: "#000",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-5px",
                    right: "-5px",
                    width: "10px",
                    height: "10px",
                    backgroundColor: "#000",
                    clipPath: "polygon(0 0, 100% 50%, 0 100%)",
                  }}
                ></div>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div>
      <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css" />
      <link
        rel="stylesheet"
        href="https://www.w3schools.com/lib/w3-theme-black.css"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <style jsx>{`
        #BookingTable {
          font-family: Arial, Helvetica, sans-serif;
          border-collapse: collapse;
          width: 100%;
        }

        #BookingTable td,
        #BookingTable th {
          border: 1px solid #ddd;
          padding: 8px;
        }

        #BookingTable tr:nth-child(even) {
          background-color: #ffffff;
        }

        #BookingTable tr:hover {
          background-color: #ddd;
        }

        #BookingTable th {
          padding-top: 12px;
          padding-bottom: 12px;
          background-color: #04aa6d;
          color: white;
        }
      `}</style>

      {/* <!-- Bookings --> */}
      <div
        className="w3-row-padding w3-padding-64 w3-theme-l5 w3-center"
        id="Bookings"
        style={{ position: "relative", minHeight: "100vh" }}
      >
        <h1>Your Bookings</h1>
        <p>
          Here you can see all of your students that are assigned to you.
          <br></br>
          <br></br>
          Anything submitted through your bespoke partnership form will be
          automatically assigned to you and displayed here.
          <br></br>
          Other bookings will require one of our staff members to assign them to
          you.
          <br></br>
          If you expected to see a student here and they are not, please contact
          us so we can properly assign them to you.
          <br></br>
          <br></br>
          Every student is required to complete a "Student enrolment Forms".
          Here you can moniter, manage, assist and email the forms straight to
          the students and the parents.
        </p>
        <br></br>
        <h3>Progress:</h3>
        <ProgressLegend />
        <br></br>
        {View === "Table" ? (
          <button onClick={(e) => setView("Cards")} style={{ width: "25%" }}>
            Cards View
          </button>
        ) : (
          <button onClick={(e) => setView("Table")} style={{ width: "25%" }}>
            Table View
          </button>
        )}
        <br></br>
        <br></br>
        <TextField
          id="FilterEverything"
          label="Search..."
          variant="outlined"
          value={FilterEverything}
          onChange={handleFilterEverything}
          fullWidth
          sx={{ mt: 2, my: "auto", maxWidth: "500px" }}
          style={{ width: "100%" }}
        />
        <br></br>
        <br></br>
        {View === "Table" ? (
          <>
            <ConsultantBookingTable
              Arr_Bookings={Arr_Bookings_Filtered}
              Arr_BasicSEFPages={Arr_BasicSEFPages}
              Arr_AdvancedSEFPages={Arr_AdvancedSEFPages}
              countUnpaidInvoices={countUnpaidInvoices}
              checkSEFProgress={checkSEFProgress}
              handleExpand={handleExpand}
              handleOpenSEFPage={handleOpenSEFPage}
              obj_EC={obj_EC}
              Arr_ECs={Arr_ECs}
              handleSendSEFPage={handleSendSEFPage}
            />
          </>
        ) : (
          <>
            <ConsultantBookingCards
              Arr_Bookings={Arr_Bookings_Filtered}
              Arr_BasicSEFPages={Arr_BasicSEFPages}
              Arr_AdvancedSEFPages={Arr_AdvancedSEFPages}
              countUnpaidInvoices={countUnpaidInvoices}
              checkSEFProgress={checkSEFProgress}
              screenWidth={screenWidth}
              handleExpand={handleExpand}
              handleOpenSEFPage={handleOpenSEFPage}
              obj_EC={obj_EC}
              Arr_ECs={Arr_ECs}
              handleSendSEFPage={handleSendSEFPage}
            />
          </>
        )}
      </div>

      {/* <!-- Footer --> */}
      <footer className="w3-container w3-padding-32 w3-theme-d1 w3-center">
        <h4>Follow Us</h4>
        <a
          className="w3-button w3-large w3-teal"
          href="https://www.facebook.com/@investineducation/"
          title="Facebook"
        >
          <i className="fa fa-facebook"></i>
        </a>
        <a
          className="w3-button w3-large w3-teal"
          href="https://twitter.com/investin_ed"
          title="Twitter"
        >
          <i className="fa fa-twitter"></i>
        </a>

        <a
          className="w3-button w3-large w3-teal"
          href="https://www.instagram.com/investin_education/?hl=en"
          title="Instagram"
        >
          <i className="fa fa-instagram"></i>
        </a>
        <a
          className="w3-button w3-large w3-teal w3-hide-small"
          href="https://uk.linkedin.com/company/investin"
          title="Linkedin"
        >
          <i className="fa fa-linkedin"></i>
        </a>
        <a
          className="w3-button w3-large w3-teal"
          href="https://investin.org/"
          title="Website"
        >
          <i className="fa fa-globe"></i>
        </a>
      </footer>
    </div>
  );
};

export default ConsultantBookings;
